import { Card, CryptoIcon } from '../../components'
import { EtherscanAddress } from '../../components/etherscan-address'
import { PoolsTable } from '../../components/pools-table'

export function LoansHistory() {
    const dataClasses = 'not-italic font-light text-sm leading-3 py-4'
    const enfasisClasses = ' text-black '
    return (
        <div className='grid grid-cols-8 gap-16 pt-12 h-full'>
            <div className='col-span-8'>
                <Card className='w-full h-full py-8'>
                    <h3>Loan history</h3>
                    <PoolsTable
                        headers={[
                            'Asset',
                            'Loan Pool',
                            'Amount (Principle)',
                            'Amount(Interest)',
                            'Total',
                            'Term',
                            'Interest Rate',
                            'Monthly Repayment',
                            'Transaction ID',
                        ]}
                        items={
                            <>
                                <tr
                                    className='border-b border-gray border-solid border-opacity-10 group'
                                    data-test-id={`transaction-item`}>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex flex-row justify-center w-full p-4'>
                                            <CryptoIcon name='USDC' />
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-light'>
                                                Masa USDC A Pool
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                $2,500.00
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                $187.50
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-normal'>
                                                $2687.50
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-gray4 font-light'>
                                                6 months
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-light'>
                                                15% APY
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-black font-light'>
                                                $447.92
                                            </p>
                                        </div>
                                    </td>
                                    <td
                                        className={`${dataClasses} ${enfasisClasses}`}>
                                        <div className='flex break-words overflow-visible truncate text-left flex-col items-center'>
                                            <p className='text-linkYellow font-semibold'>
                                                <EtherscanAddress
                                                    address={'0x7899...67h7'}
                                                />
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            </>
                        }
                    />
                </Card>
            </div>
        </div>
    )
}
